import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'

interface Props {
  text: string
  size?: string
  variant?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleComponent',
  props: {
    text: null,
    size: null,
    variant: null
  },
  setup(__props: any) {

const props = __props as {
  text: string
  size?: string
  variant?: string
}



const classes = computed(() => {
  let result = ''
  switch (props.size) {
    case 'lg':
      result = 'text-headingXl lg:text-heading2xl'
      break
    default:
      result = 'text-headingXl xl:text-headingXl'
      break
    case 'sm':
      result =
        'text-headingSm xl:text-headingSm underline underline-offset-4 decoration-2'
      break
  }
  if (props.variant == 'dark') {
    result += ' text-slateGray'
  } else {
    result += ' text-stone'
  }
  return result
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h1", {
    class: _normalizeClass(["font-serif text-center mb-2 mx-6", _unref(classes)])
  }, _toDisplayString(props.text), 3))
}
}

})